module.exports = __webpack_public_path__ + "img/logo_red.ceea85fe.svg";